{
  "page": {
    "title": "Templates",
    "subtitle": "Manage shared product templates and their validation rules. All admins see every template.",
    "regionErrors": "Region errors",
    "newTemplate": "+ New template"
  },
  "filters": {
    "search": "Search",
    "searchPlaceholder": "Search by code, name, alias…",
    "status": "Status",
    "statusAll": "All",
    "statusActive": "Active",
    "statusInactive": "Inactive",
    "type": "Type",
    "typeAll": "All types",
    "typePrint": "Print",
    "typeEmbroidery": "Embroidery",
    "productKind": "Product kind",
    "productKindAll": "All kinds",
    "productKindApparel": "Apparel",
    "productKindHomeDecor": "Home decor",
    "material": "Material",
    "materialAll": "All materials",
    "materialFabric": "Fabric",
    "materialWood": "Wood",
    "materialMirrorAcrylic": "Mirror acrylic",
    "materialFrostedAcrylic": "Frosted acrylic",
    "materialClearAcrylic": "Clear acrylic",
    "showDeleted": "Show deleted"
  },
  "table": {
    "selectAll": "Select all rows on this page",
    "selectRow": "Select template {{code}}",
    "code": "Code",
    "name": "Name",
    "productKind": "Product kind",
    "partCount": "Parts",
    "layerCount": "Layers",
    "regionCount": "Regions",
    "status": "Status",
    "updated": "Updated",
    "actions": "Actions"
  },
  "status": {
    "active": "Active",
    "inactive": "Inactive",
    "deleted": "Deleted"
  },
  "rowActions": {
    "restore": "Restore",
    "toggleActiveLabel": "Toggle active for {{code}}",
    "on": "On",
    "off": "Off"
  },
  "bulk": {
    "selectedCount": "{{n}} selected",
    "activate": "Activate",
    "deactivate": "Deactivate",
    "export": "Export"
  },
  "empty": "No templates match the current filters.",
  "toasts": {
    "activated": "Templates activated",
    "deactivated": "Templates deactivated",
    "activatedDesc": "{{modified}} template(s) activated",
    "activatedPartialDesc": "{{modified}} activated ({{already}} already active)",
    "deactivatedDesc": "{{modified}} template(s) deactivated",
    "deactivatedPartialDesc": "{{modified}} deactivated ({{already}} already inactive)",
    "bulkActivateFailed": "Bulk activate failed",
    "bulkDeactivateFailed": "Bulk deactivate failed",
    "exportReady": "Export ready",
    "exportReadyDesc": "Exported {{count}} of {{requested}} selected template(s)",
    "exportReadyAllDesc": "Exported all {{count}} template(s)",
    "exportFailed": "Export failed",
    "templateActivated": "Template activated",
    "templateDeactivated": "Template deactivated",
    "activateFailed": "Activate failed",
    "deactivateFailed": "Deactivate failed",
    "restored": "Template restored",
    "restoreFailed": "Restore failed"
  },
  "confirmToggle": {
    "activateTitle": "Activate template?",
    "deactivateTitle": "Deactivate template?",
    "activateDesc": "Re-enable template \"{{name}}\" ({{code}}). The template will appear everywhere it is used.",
    "deactivateDesc": "Deactivate template \"{{name}}\" ({{code}}). Surfaces using this template will be temporarily hidden until re-enabled.",
    "activateConfirm": "Activate",
    "deactivateConfirm": "Deactivate",
    "cancel": "Cancel",
    "deactivateDescInUse": "Deactivate template \"{{name}}\" ({{code}})? It is used by {{blueprints}} blueprint(s) and {{skus}} SKU(s) — {{names}}{{more}}. Those SKUs lose this template, and a blueprint left with no print areas cannot be put on sale."
  },
  "createDialog": {
    "title": "New template",
    "subtitle": "Create a minimal template (code + EN name + type). Add regions / validation rules later on the detail page.",
    "codeLabel": "Code *",
    "codeHint": "Only a-z, A-Z, 0-9, underscore or hyphen (1-50 chars).",
    "nameLabel": "Name (EN) *",
    "typeLabel": "Type *",
    "cancel": "Cancel",
    "submit": "Create",
    "submitting": "Creating…",
    "successTitle": "Template created",
    "errorTitle": "Create template failed"
  },
  "inUse": {
    "title": "This template is in use",
    "description": "It is referenced by {{blueprints}} blueprint(s) and {{skus}} SKU(s). Deactivating it removes it from the SKU template picker.",
    "blueprintLevel": "Applies to the whole blueprint",
    "skuList": "SKUs: {{skus}}",
    "consequence": "Print areas are derived from a SKU’s templates, and a blueprint with no print areas cannot be put on sale. Existing orders are not affected.",
    "cancel": "Keep it active",
    "confirm": "Deactivate anyway",
    "working": "Deactivating…"
  },
  "notReady": {
    "perTemplate": "{{code}}: {{reasons}}",
    "andMore": "…and {{n}} more template(s)",
    "TEMPLATE_ACTIVE_NO_PART": "has no print area — add at least one area, or one part with an artwork layer",
    "TEMPLATE_ACTIVE_PART_NO_LAYER": "a part has no layers — add at least one layer",
    "TEMPLATE_ACTIVE_NO_ARTWORK_LAYER": "has no artwork layer, so nothing can be printed on it",
    "TEMPLATE_LAYER_ARTWORK_NO_REGION": "an artwork layer has no sized print region",
    "TEMPLATE_LAYER_ARTWORK_NO_FILE": "an artwork layer has no file"
  }
}
